import http from 'hub-http/clients/apiClient';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const SHORTS_API = `/academy-catalog/v2/shorts/`;
export const SHORTS_PUBLIC_API = `/academy-catalog-public/v1/shorts`;
const GET_SHORT_FORM_CONTENT = registerQuery({
  fieldName: 'shorts',
  args: ['shortId'],
  fetcher: ({
    shortId
  }) => http.get(`${SHORTS_API}${shortId}`)
});
const GET_PUBLIC_SHORT_FORM_CONTENT = registerQuery({
  fieldName: 'shortsPublic',
  args: ['shortId'],
  fetcher: ({
    shortId
  }) => noAuthApiClient.get(`${SHORTS_PUBLIC_API}/id/${shortId}`)
});
export const useShortFormContent = (shortId, skip) => {
  const {
    data: shortFormContent,
    loading: shortFormContentLoading,
    error: shortFormContentError
  } = useQuery(GET_SHORT_FORM_CONTENT, {
    skip,
    variables: {
      shortId
    }
  });
  return {
    shortFormContent,
    shortFormContentLoading,
    shortFormContentError
  };
};
export const useShortFormContentPublic = (shortId, skip) => {
  const {
    data: shortFormContent,
    loading: shortFormContentLoading,
    error: shortFormContentError
  } = useQuery(GET_PUBLIC_SHORT_FORM_CONTENT, {
    skip,
    variables: {
      shortId
    }
  });
  return {
    shortFormContent,
    shortFormContentLoading,
    shortFormContentError
  };
};